import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useLazyQuery, useSubscription } from '@apollo/client';
import { USER_NOTIFICATION_SUBSCRIPTION, USER_NOTIFICATION_QUERY } from '../../graph/UserGraph';



export default function NotificationsMenu({ isDark }) {
  // const classes = useStyles(props);
  const [notifications, setNotifications] = useState([]);
  const [getLazyNotifications, lazyNotifications] = useLazyQuery(USER_NOTIFICATION_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: ((queryData) => {
      setNotifications(queryData.me.notifications)
      console.log(queryData.me.notifications, "notifications loaded")
    })

  });

  // function LatestNotification() {
  const { data, loading } = useSubscription(USER_NOTIFICATION_SUBSCRIPTION, {
    onData: (wsData) => {
      let new_notification = wsData.data.data.allNotificationsChannel
      console.log(new_notification)
      console.log(notifications, "thes are existing notifications")
      // let current_notifications = notifications
      var newNotificationArray = [...notifications, new_notification]
      console.log(newNotificationArray, "this is new notifications array")
      setNotifications(newNotificationArray)
    }
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  // const ws = useRef(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    getLazyNotifications()
    // ws.current.send(JSON.stringify({ "message": "hi notifications got clicked" }))
  };
  const handleClose = () => {
    setAnchorEl(null);
  };



  useEffect(() => {
    getLazyNotifications()
  }, [])

  useEffect(() => {
    getLazyNotifications()
  }, [data])


  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Notifications">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'notifications-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <Badge
              badgeContent={notifications.length ? notifications.length : 0}
              sx={{
                color: isDark ? 'white' : '#000000',
                "& .MuiBadge-badge": {
                  color: "lightgreen",
                  backgroundColor: "green"
                }
              }}

            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        sx={{
          color: isDark ? 'white' : '#000000',
          "& .MuiMenu-root": {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? "#424242" : "#FFFFFF"
          },
          "& .MuiPaper-root": {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? "#424242" : "#FFFFFF"
          },
          "& .MuiMenu-list": {
            color: isDark ? 'white' : '#000000',
            backgroundColor: isDark ? "#424242" : "#FFFFFF"
          },
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            // '& .MuiAvatar-root': {
            //     width: 32,
            //     height: 32,
            //     ml: -0.5,
            //     mr: 1,
            // },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: isDark ? "#424242" : "#FFFFFF",
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {notifications ?
          (notifications.map((notification) => {
            return (
              <div key={notification.id}>
                <MenuItem key={notification.id} >
                  {notification.notification}
                </MenuItem>
                <Divider />
              </div>)
          }))
          :
          (
            <div>
              <MenuItem key="no-notification" >
                No Notifications
              </MenuItem>
              <Divider />
            </div>)}
      </Menu>
    </React.Fragment>
  );
}
